<template>
  <div>
    <div
      class="absolute inset-0 z-30 flex flex-col min-h-screen pt-16 -mt-24 overflow-auto "
    >
      <div class="flex-1"></div>
      <h1 class="text-4xl font-bold text-center">Modules</h1>
      <p class="text-sm font-light text-center">
        Cliquez sur un module pour commencer
      </p>
      <div
        class="container grid px-8 mx-auto mt-96 gap-y-12 gap-x-24 xl:mt-12 place-content-center xl:grid-cols-2 grid-col-1"
      >
        <div
          class="relative flex items-center cursor-pointer"
          v-for="(app, index) of modules"
          :key="index"
          @click="setCurrentModule(app)"
        >
          <div
            class="relative z-0 flex flex-1 flex-shrink-0 p-8 mx-auto transition-all bg-gray-200 rounded-md shadow-none bg-opacity-40 hover:shadow-xl"
            style="border: 1px solid #888"
          >
            <div class="flex flex-col flex-1">
              <p
                class="mb-4 text-lg font-black tracking-wide uppercase text-secondary"
              >
                {{ app.name }}
              </p>

              <p class="mt-2 leading-6 text-gray-600 dtext-clamp">
                {{ app.hardDescription }}
              </p>

              <div class="mt-4">
                <label
                  @click.stop="info = app"
                  for="info-modal"
                  class="italic normal-case btn btn-primary btn-sm"
                >
                  En savoir plus
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="hidden w-6 h-6 ml-2"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </label>
              </div>
            </div>

            <div class="">
              <img
                class="object-contain object-center w-auto h-32 ml-auto"
                :src="app.img"
                :alt="app.img"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="flex-1"></div>
    </div>

    <input type="checkbox" id="info-modal" class="modal-toggle" />
    <div class="modal">
      <div class="transition-all modal-box" :class="{ 'max-w-[80%] ': demo }">
        <div v-if="!demo">
          <h1 class="text-4xl font-bold text-center">{{ info.name }}</h1>
          <div class="flex justify-center mt-4">
            <div
              class="flex items-center justify-center w-16 h-16 rounded-full bg-primary animate-bounce"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-12 h-12 text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
          </div>
          <p class="mt-4 tracking-wide">{{ info.description }}</p>
        </div>

        <div v-else>
          <h1 class="text-4xl font-bold text-center">Démonstration</h1>

          <div
            class="
              w-full
              h-[60vh]
              mt-4
              overflow-hidden
              relative
              flex
              justify-center
              items-center
            "
          >
            <button
              v-if="!demolink"
              @click="demolink = '/img/gifs/demo.gif'"
              class="absolute flex items-center justify-center w-12 h-12 rounded-full bg-primary btn btn-square btn-circle"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-8 h-8 text-white"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>
            <img
              class="object-contain w-full h-full"
              :src="
                demolink ||
                  'https://images.unsplash.com/photo-1633113089635-115b38c66c49?ixlib=rb-1.2.1&ixid=MnwxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80'
              "
              alt=""
            />
          </div>
        </div>

        <div class="modal-action">
          <button
            v-show="!demo"
            @click="demo = true"
            for="show-demo-modal"
            class="normal-case btn btn-secondary"
          >
            Voir la demo
          </button>
          <button
            v-if="demolink"
            @click="replaydemo"
            class="normal-case btn btn-secondary"
          >
            Rejouer
          </button>
          <label
            for="info-modal"
            @click="
              demo = false;
              demolink = '';
            "
            class="normal-case btn btn-primary"
            >Fermer</label
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import authMixin from "@/utils/mixins/auth.mixin.js";
export default {
  mixins: [authMixin],

  data() {
    return {
      startDicdaticiel: "true",
      info: {},
      demo: false,
      demolink: "",
      listModules: [
        {
          name: "Analyse Complète des acteurs",
          description: "Module d'Analyse complète des acteurs",
          img: "appc.svg",
          uri: "/app/analyse-complete-acteurs",
          color: "#006837"
        },
        {
          name: "Analyse des risques",
          description: "Module de gestion des risques",
          img: "arr.svg",
          uri: "/app/analyse-risques",
          color: "#2e3192"
        },
        {
          name: "Matrice de priorisation",
          description: "Module de Priorisation des activités",
          img: "mp.svg",
          uri: "/app/matrice-priorisation",
          color: "#009245"
        },
        {
          name: "Modèles de résultat",
          description: "Module du modèle de résultats",
          img: "mr.svg",
          uri: "/app/modele-resultats",
          color: "#116d6d"
        }
      ],

      bValues: null
    };
  },

  computed: {
    modules() {
      if (this.$user) {
        return this.$user.listEnterpriseModules.map(x => ({
          ...this.getModuleInfos(x.moduleAbbre),
          id: x.applicationModuleID,
          abbreviation: x.moduleAbbre,
          name: x.moduleName,
          description: x.moduleDescription,

          img: x.moduleImage,
          uri: this.getModuleURL(x.moduleAbbre)
        }));
      }

      return [];
    }
  },

  created() {
    this.bValues = [
      {
        name: "Tools",
        uri: "/app/tools"
      }
    ];
  },

  mounted() {
    this.$nextTick(() => {
      this.colorizeModules();
    });
  },

  methods: {
    getModuleInfos(abbreviation) {
      const response = {
        moduleDescription: "",
        hardDescription: "",
        moduleDemarche: []
      };

      switch (abbreviation) {
        case "AP":
          response.hardDescription =
            "C’est un processus qui permet le positionnement de chaque acteur par rapport à son engagement dans un projet.";
          response.moduleDescription =
            "L'analyse des parties prénantes consiste à identifier les différents acteurs intervenants dans le projet, les classifier par catégorie spécifique et à déterminer leurs contributions et leur niveau d’influence par rapport à la réalisation ou l’atteinte des résultats du projet. Analyser leurs positions dans la cible en fonction de leurs niveaux d’engagements et définir les relation entre acteurs";
          response.moduleDemarche = [
            "Création d’un projet",
            "Création d’un axe de reflexion",
            "Identification des acteurs à intégrer dans l’axe de reflexion du projet traité",

            "Analyse du jeu des acteurs",
            "Visualisation du diagramme du jeu des acteurs",
            "Définition des relations entre acteurs",
            "Édition du rapport"
          ].map((value, index) => {
            switch (index) {
              case 3:
                return {
                  title: value,
                  subs: [
                    "Classification des acteurs en fonctions de trois types (Partie prénante institutionelle, Partenaire technique et financier, Autre acteur)",
                    "Evaluations des acteurs en fonctions de leur influence (Directe, Assez directe, Peu directe, Indirecte)",
                    "Estimation du niveau d'implication des acteurs (Engagé, Indécis, Peu engagé)"
                  ]
                };

              case 2:
                return {
                  title: value,
                  subs: [
                    "Appréciation de la pertinence des acteurs identifiés",
                    "Suppression des acteurs non pertinents / Ajout de nouveaux acteurs pertinents",
                    "Validations des acteurs"
                  ]
                };

              default:
                return { title: value };
            }
          });
          return response;
        case "AR":
          response.hardDescription =
            "C’est un processus qui permet le traitement de l’ensemble et le niveau des risques pouvant impacter la mise en œuvre d’un projet afin de définir des mesures palliatives éventuel dans le cas échéant";
          response.moduleDescription =
            "Consiste à analyser l’ensemble et le niveau des risques pouvant freiner la mise en œuvre du projet afin de définir des mesures palliatives le cas échéant.";
          response.moduleDemarche = [
            "Création d’un projet",
            "Création d’un axe de reflexion",
            "Identification des different risques pour l’axe de reflexion du projet traitée",
            "Appréciation de la pertinence des risques identifiés",
            "Suppression des risques non pertinents / Ajout d'autres risques pertinents",
            "Validations des risques",
            "Evaluation des risques par rapport à leurs probabilités de survenance et à leurs impacts",
            "Visualisation de la matrice d'évaluation des risques",
            "Édition du rapport"
          ];
          return response;
        case "MR":
          (response.hardDescription =
            "C’est un processus qui permet l’identification des résultats attendus de la planification d’un projet allant des impacts, des effets aux produits et la détermination des différentes connexions entre eux."),
            (response.moduleDescription =
              " c’est l’activité qui permet d’identifier les résultats attendus de la planification allant des impacts aux produits et déterminer les liens entre les différents résultats.");
          response.moduleDemarche = [
            "Création d’un projet",
            "Création d’un axe de reflexion",
            "Identifier les résultats attendus possibles",
            "Appréciation de la pertinence des résultats identifiés",
            "Suppression des résultats non pertinents / Ajout des résultats pertinents",
            "Validations des echanges",
            "Catégoriser les résultats en terme d'impacts, effets ou produits",
            "Définir les liens entre les differents résultats",
            "Édition du rapport"
          ];
          return response;
        case "MP":
          (response.hardDescription =
            "C’est un processus qui permet l’identification de de chaque action possible et réalisable d’un projet et sa catégorisation en fonction de son importance et de sa facilité/difficulté de mise en œuvre"),
            (response.moduleDescription =
              "consiste à identifier toutes les actions possibles d’un projet et les classer par ordre de priorisation en fonction de l’importance et la facilité/difficulté de mise en œuvre ");
          response.moduleDemarche = [
            "Création d’un projet",
            "Création d’un axe de reflexion",
            "Identifier les actions nécessaires à la mise en œuvre du projet",
            "Appréciation de la pertinence des actions identifiés",
            "Suppression des actions non pertinentes / Ajout des Actions pertinentes",
            "Validations des actions",
            "Priorisation de chaque action identifiée suivant «son importance et la facilité de sa mise en œuvre»",
            "Visualisation de la matrice de priorisation des actions",
            "Édition du rapport"
          ];
          return response;

        default:
          break;
      }
    },

    replaydemo() {
      this.demolink = "";
      this.demolink = "/img/gifs/demo.gif";
    },
    colorizeModules() {
      const modules = document.querySelectorAll(".module");

      this.listModules.forEach((mod, id) => {
        modules[id].style.border = "solid 1px " + mod.color;
      });
    },

    setCurrentModule(item) {
      this.$store.commit("setCurrentModule", item);
      localStorage.setItem("currentModule", JSON.stringify(item));
      this.$router.push("/app/description");
      //this.$router.push("/app/folders");
    }
  }
};
</script>

<style lang="scss" scoped>
.text-clamp {
  display: -webkit-box;

  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.test {
  border: solid;
  width: 500px;
  padding: 50px;
}

.list-modules {
  width: 80vw;
  height: 80vh;
  margin: 10vh 10vw;
  border: solid transparent 1px;
  display: flex;
  align-items: center;
  justify-content: center;

  .list-modules-container {
    display: flex;
    flex-wrap: wrap;
    margin-top: 5vh;

    .module {
      width: 32%;
      margin: 1.5vh 0.5%;
      min-height: 120px;
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: space-between;
      box-shadow: 0 20px 30px -16px rgba(9, 9, 16, 0.2) !important;
      padding: 10px;
      cursor: pointer;
      background: #eee;
      border-radius: 0.5rem;

      .module-img {
        width: 100px;
        height: 100px;
        overflow: hidden;
        display: inline-block;
        vertical-align: middle;

        img {
          height: 95px;
          width: 95px;
        }
      }

      .module-details {
        display: inline-block;
        vertical-align: middle;
        font-family: "roboto";
        padding: 0 10px;
        margin-top: 20px;
        margin-left: 5px;
        width: calc(100% - 100px);
        position: relative;
        top: -10px;

        .module-name {
          font-weight: 600;
          font-size: 1.5em;
          line-height: 1em;
        }

        .module-desc {
          display: inline-block;
          font-style: italic;
          font-size: 0.95em;
          transform: translateY(-0.75em);
        }
      }

      &:hover {
        transform: scale(0.95);
      }
    }
  }
}
</style>
